/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Name"
  
}) {
let eventValueData = fromData.useDataValue({ viewPath,
context: 'event',
})
let globalFeatureFlagsIsNewCalendarEnabledValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_new_calendar_enabled',
})
let aggregateData = fromHelpers.getAppointmentName(eventValueData, globalFeatureFlagsIsNewCalendarEnabledValueData)
let eventAppointmentValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment',
format: fromFormat.isAppointmentScheduled,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event"
 data="global.feature_flags.is_new_calendar_enabled"
 aggregate="helpers.js getAppointmentName"
 text={aggregateData}
 weight="medium"
 size="large"
 color={eventAppointmentValueData ? dtColorsNeutral900 : dtColorsNeutral500}
 data="event.appointment"
 format="/Data/format.js isAppointmentScheduled"
/>
{children}
</React.Fragment>)
}